import {
  createContext,
  useContext,
  useEffect,
  useState,
  type ReactNode,
} from "react";
import { loadSettings, SETTINGS_DEFAULTS, type Settings } from "../lib/settings";

const SettingsContext = createContext<Settings>(SETTINGS_DEFAULTS);
const SettingsLoadedContext = createContext(false);

export function SettingsProvider({ children }: { children: ReactNode }) {
  const [settings, setSettings] = useState<Settings>(SETTINGS_DEFAULTS);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let alive = true;
    loadSettings().then((s) => {
      if (!alive) return;
      setSettings(s);
      setLoaded(true);
    });
    return () => {
      alive = false;
    };
  }, []);

  return (
    <SettingsLoadedContext.Provider value={loaded}>
      <SettingsContext.Provider value={settings}>
        {children}
      </SettingsContext.Provider>
    </SettingsLoadedContext.Provider>
  );
}

export function useSettings(): Settings {
  return useContext(SettingsContext);
}

/** True once the saved settings have loaded (or failed and fallen back). */
export function useSettingsLoaded(): boolean {
  return useContext(SettingsLoadedContext);
}
